import React from "react";
import { useSelector } from "react-redux";
import { useActiveFilters, useFilter, useFilterSync } from "web/react/hooks/filters";
import { ReduxStoreState } from "web/redux/store";
import { gettext } from "web/script/modules/django-i18n";
import { FilterSection } from "./filter-section";
import { MultiRangeSlider } from "./multi-range-slider";
import styles from "./price-filters.module.css";

export function PriceFilters(): JSX.Element {
    const { min, max, minActiveValue, maxActiveValue } = useFilter("final_price");
    const { onChange } = useFilterSync();
    const existingUrl = useSelector((state: ReduxStoreState) => state.filters.ui.url as string);
    const { isActivePriceMin, isActivePriceMax } = useActiveFilters("final_price");

    return (
        <FilterSection title={`${gettext("feed.filters.shop_by_price.title")}`}>
            <div className={styles.wrapper}>
                <MultiRangeSlider
                    min={min}
                    max={1000}
                    maxPlus={max}
                    onChange={(minVal, maxVal) => {
                        let url = new URL(existingUrl, window.location.href);
                        url.searchParams.set("final_price_to", `${maxVal}`);
                        url.searchParams.set("final_price_from", `${minVal}`);
                        onChange(url.toString());
                    }}
                    isActiveMin={isActivePriceMin}
                    isActiveMax={isActivePriceMax}
                    minActiveValue={minActiveValue}
                    maxActiveValue={maxActiveValue}
                />
            </div>
        </FilterSection>
    );
}
